import React from "react";

interface WordmarkProps {
  className?: string;
  /** Show the Telcofy map-pin mark before the wordmark. */
  withMark?: boolean;
}

const Wordmark: React.FC<WordmarkProps> = ({
  className = "",
  withMark = true,
}) => {
  return (
    <span
      className={`tf-wordmark inline-flex items-center gap-2 ${className}`}
    >
      {withMark && (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          className="h-[0.9em] w-[0.9em] flex-shrink-0"
          fill="none"
        >
          <path
            d="M12 2.25C7.72 2.25 4.25 5.72 4.25 10c0 5.69 7.04 11.4 7.34 11.64a.65.65 0 0 0 .82 0c.3-.24 7.34-5.95 7.34-11.64 0-4.28-3.47-7.75-7.75-7.75Z"
            className="stroke-brand-500"
            strokeWidth="1.75"
            strokeLinejoin="round"
          />
          <circle cx="12" cy="9.75" r="2.25" fill="currentColor" />
        </svg>
      )}
      <span className="leading-none">
        <span>Telco</span>
        <span className="fy">fy</span>
      </span>
    </span>
  );
};

export default Wordmark;
